"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiniFormulario = exports.TblTelefonoInfo = exports.InfoInteres = exports.InfoLogin = exports.DatosAlumni = void 0;
var React = require("react");
var reactstrap_1 = require("reactstrap");
var sweetalert2_1 = require("sweetalert2");
var select_modif_js_1 = require("./utils/select_modif.js");
var required_select_js_1 = require("./utils/required_select.js");
var verificacion_cedula_mini_js_1 = require("./utils/verificacion_cedula_mini.js");
var aviso_privacidad_js_1 = require("./utils/aviso_privacidad.js");
require("../assets/css/formulario.css");
var AiIcons = require("react-icons/ai");
var FaIcons = require("react-icons/fa");
var Banner = require("../assets/img/BannerActDatos.png");
var TriagunloAzul = require("../assets/img/AzulPng.png");
var TrianguloVerde = require("../assets/img/VerdePng.png");
var OpcionesList = require("../opciones.js");
var SERVER_URL = process.env.REACT_APP_SERVER_URL;
//const SERVER_URL = "https://wsalumni.espol.edu.ec/api/";
//const SERVER_URL = "https://wssaac.espol.edu.ec/formt/api/";
//const SERVER_URL = "http://192.168.253.6:8091/api/"; // prueba
//const SERVER_URL = "http://localhost:58046/api/";
var DatosAlumni = /** @class */ (function () {
    function DatosAlumni() {
        this.idpersona = 0;
        this.numeroidentificacion = "";
        this.apellidos = "";
        this.nombres = "";
        this.nombrecompleto = "";
        this.email = "";
        this.emailalterno = "";
        this.fechanacimiento = "";
        this.anio = 0;
        this.mes = 0;
        this.dia = 0;
        this.sexo = "";
        this.direcciondomicilio = "";
        this.idpais = 0;
        this.pais = "";
        this.ciudad = "";
        this.idcanton = 0;
        this.codpais = "";
        this.codarea = "";
        this.telefonocelular = "";
        this.nombreunidad = "";
        this.codacad = "";
        this.nombrecarrera = "";
        this.fechagraduacion = "";
        this.aniograduacion = 0;
        this.codestudiante = "";
        this.estadocivil = "";
        this.idnacionalidad = "";
        this.nombreprograma = "";
        this.fechaCedulacion = "";
        this.diaCedulacion = "";
        this.mesCedulacion = "";
        this.anioCedulacion = "";
    }
    return DatosAlumni;
}());
exports.DatosAlumni = DatosAlumni;
var InfoLogin = /** @class */ (function () {
    function InfoLogin() {
        this.email = "";
        //fecharegistro: string = "";
        this.tiporedsocial = "";
        this.tipoalumni = "";
        //ultimoCambio: string = "";
        this.idalumnisociallogin = 0;
        this.idpersona = 0;
    }
    return InfoLogin;
}());
exports.InfoLogin = InfoLogin;
var InfoInteres = /** @class */ (function () {
    function InfoInteres() {
        this.idalumniinfointeres = 0;
        this.idpersona = 0;
        this.tipotelefono = "";
        this.codigopais = "";
        this.emailalterno = "";
        this.nombreempresa = "";
        this.cargoempresa = "";
        this.redessociales = "";
        this.interes = "";
        this.otrointeres = "";
        this.actividadesagentecambio = "";
        this.mediocontacto = "";
        //ultimoCambio: string = "";
        this.codigoarea = "";
        this.numerotelefono = "";
        this.idpaisresidencia = 0;
        this.niveldocencia = "";
        this.situacionlaboral = "";
    }
    return InfoInteres;
}());
exports.InfoInteres = InfoInteres;
var TblTelefonoInfo = /** @class */ (function () {
    function TblTelefonoInfo() {
        this.idtelefono = 0;
        this.idpersona = 0;
        this.codigoarea = "";
        this.numerotelefono = "";
        this.tipotelefono = "";
        this.version = 1;
        this.codigopais = "";
        this.ext = "";
        this.estado = "A";
    }
    return TblTelefonoInfo;
}());
exports.TblTelefonoInfo = TblTelefonoInfo;
var MiniFormulario = /** @class */ (function (_super) {
    __extends(MiniFormulario, _super);
    function MiniFormulario(props) {
        var _this = _super.call(this, props) || this;
        _this.abortController = new window.AbortController();
        _this.state = {
            loading: true, error: null,
            identificacion: "", dia: "", mes: "", anio: "", idpersona: 0,
            loginUP: true, valDataUp: true,
            paisesList: [], paisesSelectList: [], paisFonoSelectList: [],
            cedulaModal: true, cargandoValidAlert: false, cedulaAlert: false, mensajeAlerta: "",
            modalEnd: false, alertCargando: false, alertExito: false, alertError: false,
            loginModal: false,
            tieneDatosPostgrados: false, datosalumni: new DatosAlumni(), infointeres: new InfoInteres(),
            telecasa: new TblTelefonoInfo(), telecel: new TblTelefonoInfo(), tipoFonoSelect: "", alertaTelefono: false, mensajeTelefono: [],
            alertPaisResidencia: false,
            graduadode: [], opcionesInteres: [], opcionesRedes: [], opcionesAgenteCambio: [],
            loginOpen: true, redSocial: "", emailRedsocial: "", consentimiento: false, modalAviso: false
        };
        //METODOS
        _this.initializeTelefonos = _this.initializeTelefonos.bind(_this);
        _this.cargarDatos = _this.cargarDatos.bind(_this);
        _this.cargarNacionalidad = _this.cargarNacionalidad.bind(_this);
        _this.exceptionsInput = _this.exceptionsInput.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSelectChange = _this.handleSelectChange.bind(_this);
        _this.getDatosAlumni = _this.getDatosAlumni.bind(_this);
        _this.showNewQuestions = _this.showNewQuestions.bind(_this);
        _this.resetFormulario = _this.resetFormulario.bind(_this);
        _this.validarTelefonos = _this.validarTelefonos.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.getAllPersonaInteres = _this.getAllPersonaInteres.bind(_this);
        _this.closeLoginRedes = _this.closeLoginRedes.bind(_this);
        _this.closeLoginEspol = _this.closeLoginEspol.bind(_this);
        _this.closeVerificacionCedula = _this.closeVerificacionCedula.bind(_this);
        _this.closeVerificacionCedulaMini = _this.closeVerificacionCedulaMini.bind(_this);
        _this.getDatosInfoInteres = _this.getDatosInfoInteres.bind(_this);
        _this.showDatosInteres = _this.showDatosInteres.bind(_this);
        _this.showAvisoPrivacidad = _this.showAvisoPrivacidad.bind(_this);
        _this.closeAvisoPrivacidad = _this.closeAvisoPrivacidad.bind(_this);
        return _this;
    }
    MiniFormulario.prototype.componentDidMount = function () {
        this.initializeTelefonos();
        this.cargarDatos();
    };
    MiniFormulario.prototype.componentWillUnmount = function () {
        this.abortController.abort();
    };
    MiniFormulario.prototype.initializeTelefonos = function () {
        var telecasaalum = this.state.telecasa;
        var telecelalum = this.state.telecel;
        telecasaalum.tipotelefono = "D";
        telecelalum.tipotelefono = "C";
        this.setState({ telecasa: telecasaalum, telecel: telecelalum });
    };
    MiniFormulario.prototype.cargarDatos = function () {
        // PAISES
        //let headers = new Headers();
        //headers.append('Access-Control-Allow-Origin', 'http://localhost:37746');
        var _this = this;
        fetch('https://ws.espol.edu.ec/rest/api/pais', { signal: this.abortController.signal })
            .then(function (response) { return response.json(); })
            .then(function (data) {
            var paisesList = data.sort(function (a, b) { return a.strNombre > b.strNombre ? 1 : -1; })
                .map(function (p) { return ({
                "value": p.siIdPais,
                "label": p.strNombre.trim(),
                "link": p.siIdPais
            }); });
            var paisesFono = data.filter(function (p) { return p.strCodigoTelefonico !== null; })
                .sort(function (a, b) { return a.strNombre > b.strNombre ? 1 : -1; })
                .map(function (p) { return ({
                "value": p.strCodigoTelefonico.trim(),
                "label": p.strNombre.trim() + " - " + p.strCodigoTelefonico.trim(),
                "link": p.siIdPais
            }); });
            _this.setState({ paisesList: data, paisesSelectList: paisesList, paisFonoSelectList: paisesFono });
        }, function (error) {
            if (error.name === "AbortError") {
                console.log("AbortError controlado");
            }
            else {
                _this.setState({
                    loading: false,
                    error: error,
                    paisesList: [], paisesSelectList: []
                });
                console.log("Ocurrió un error al obtener los paises: " + error);
            }
        });
    };
    MiniFormulario.prototype.cargarNacionalidad = function () {
        var _this = this;
        var nacionalidad = this.state.paisesList.filter(function (p) { return p.siIdPais === _this.state.datosalumni.idnacionalidad; }).map(function (p) { return p.strNacionalidad; }).toString();
        document.getElementById("nacionalidad").value = nacionalidad;
    };
    MiniFormulario.prototype.getAllPersonaInteres = function () {
        var _this = this;
        fetch("api/InformacionPostgrado/GetAllPersonaInteres/" + this.state.identificacion, { signal: this.abortController.signal })
            .then(function (response) { return response.json(); })
            .then(function (responsejson) {
            if (responsejson["strEstado"] === "N") {
                var mensaje = "No pertenece al grupo de alumni.";
                sweetalert2_1.default.fire({
                    title: '¡Oh no!',
                    text: 'No pertenece al grupo de alumni.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then(function (result) {
                    if (result.isConfirmed) {
                        sweetalert2_1.default.close();
                    }
                });
                //this.setState({ cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });
            }
            else if (responsejson["strEstado"] === "I") {
                console.log("Ocurrió un error en GetInformacionInteres.");
                sweetalert2_1.default.fire({
                    title: '¡Oh no!',
                    text: 'Se ha producido un error al momento de obtener su información',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then(function (result) {
                    if (result.isConfirmed) {
                        sweetalert2_1.default.close();
                    }
                });
            }
            else {
                var idpersonaRJ = responsejson["tnumero"];
                var datospostgrados = responsejson["tdatospostgrados"];
                var datosalumni1 = responsejson["tdatosalumni"];
                var datosinteres = responsejson["tinteres"];
                var datostelefono = responsejson["ttelefonos"];
                //this.getDatosInfoInteres(idpersonaRJ, datosalumni1, datospostgrados);
                _this.showDatosInteres(idpersonaRJ, datosalumni1, datospostgrados, datosinteres, datostelefono);
            }
        });
    };
    MiniFormulario.prototype.closeLoginRedes = function (redSocial, emailUser) {
        var _this = this;
        fetch(SERVER_URL + "Informacion/GetSocialLogin/".concat(emailUser, "&").concat(redSocial), { signal: this.abortController.signal })
            .then(function (response) { return response.json(); })
            .then(function (responseJsonSocial) {
            //console.log("closeLoginRedes: ", responseJsonSocial);
            if (responseJsonSocial.status.isSuccessfully) {
                var numeroIdentificacion = responseJsonSocial.data.tidentificacion;
                _this.setState({ redSocial: redSocial, emailRedsocial: emailUser, identificacion: numeroIdentificacion }, function () {
                    _this.getAllPersonaInteres();
                });
            }
            else {
                sweetalert2_1.default.close();
                console.log("No tiene información de inicio de sesión.");
                _this.setState({ loginOpen: false, redSocial: redSocial, emailRedsocial: emailUser });
            }
        }, function (error) {
            if (error.name === "AbortError") {
                console.log("AbortError controlado");
            }
            else {
                var mensaje = "Ocurrió un error al obtener información de inicio de sesión.";
                console.log("Ocurrió un error en GetInformacionInteres: " + error);
                sweetalert2_1.default.fire({
                    title: '¡Oh no!',
                    text: 'Se ha producido un error al momento de obtener su información de inicio de sesión',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then(function (result) {
                    if (result.isConfirmed) {
                        sweetalert2_1.default.close();
                    }
                });
            }
        });
    };
    MiniFormulario.prototype.closeLoginEspol = function (numeroIdentificacion) {
        var _this = this;
        this.setState({ identificacion: numeroIdentificacion }, function () {
            _this.getAllPersonaInteres();
        });
    };
    MiniFormulario.prototype.closeVerificacionCedula = function (idpersonaRJ, datosalumni1, datospostgrados) {
        //console.log("idpersona: ", idpersonaRJ);
        //console.log("datosalumni: ", datosalumni1);
        //console.log("datospostgrados: ", datospostgrados);
        var _this = this;
        var objetoLogin = new InfoLogin();
        objetoLogin.email = this.state.emailRedsocial;
        objetoLogin.idpersona = idpersonaRJ;
        objetoLogin.tipoalumni = (datospostgrados !== null && datospostgrados.item !== null &&
            datospostgrados.item.lPostgradosGraduados !== null && datospostgrados.item.lPostgradosGraduados.length > 0) ? "P" : "G";
        objetoLogin.tiporedsocial = this.state.redSocial;
        var datosRedes = JSON.stringify({ "objeto": objetoLogin });
        //console.log("datosRedes: ", datosRedes);
        fetch(SERVER_URL + "Formulario/PostDatosLogin", {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: datosRedes
        })
            .then(function (response) { return response.json(); })
            .then(function (responsePost) {
            //console.log("responsePost: ", responsePost);
            if (responsePost.status.isSuccessfully) {
                // OBTENIENDO INFORMACION DE INFO INTERES
                fetch(SERVER_URL + "Informacion/GetInformacionInteres/" + idpersonaRJ, { signal: _this.abortController.signal })
                    .then(function (response) { return response.json(); })
                    .then(function (responseJsonInt) {
                    if (responseJsonInt.status.isSuccessfully) {
                        // INFORMACION PERSONAL
                        // ACTUALIZANDO EMAIL ALTERNO
                        if (_this.state.redSocial !== "" && _this.state.redSocial !== "I") {
                            responseJsonInt.data.tinteres.emailalterno = _this.state.emailRedsocial;
                        }
                        var carrerasgraduado = Array();
                        // agregando carrera de grado
                        if (datosalumni1 !== null && datosalumni1.nombrecarrera !== null) {
                            //console.log("carrera Grado: ", datosalumni1.nombrecarrera.toUpperCase());
                            carrerasgraduado.push(datosalumni1.nombrecarrera.toUpperCase());
                        }
                        // agregando carreras de postgrados
                        if (datospostgrados !== null && datospostgrados.item !== null) {
                            if (datospostgrados.item.lPostgradosGraduados !== null && datospostgrados.item.lPostgradosGraduados.length > 0) {
                                var itemGradLength = datospostgrados.item.lPostgradosGraduados.length;
                                var lastthree = itemGradLength - 1;
                                while (lastthree >= 0 && carrerasgraduado.length <= 3) {
                                    var carreraName = datospostgrados.item.lPostgradosGraduados[lastthree];
                                    carrerasgraduado.push(carreraName.nombrePrograma.toUpperCase());
                                    lastthree = lastthree - 1;
                                }
                            }
                        }
                        // INFORMACION INTERES
                        var infointeres = responseJsonInt.data.tinteres;
                        // OPCIONES INTERES
                        var optIntSplit = infointeres.interes.split(",");
                        var opcionesIntereses = Array();
                        optIntSplit.map(function (opc) {
                            var optionInteres = OpcionesList.InteresList.find(function (obj) { return obj.value === opc; });
                            opcionesIntereses.push(optionInteres);
                        });
                        // OPCIONES REDES SOCIALES MAS USADAS
                        var optRedSocialSplit = infointeres.redessociales.split(",");
                        var opcionesRedes = Array();
                        optRedSocialSplit.map(function (opc) {
                            var optionRedes = OpcionesList.RedesSocialesMasUsadas.find(function (obj) { return obj.value === opc; });
                            opcionesRedes.push(optionRedes);
                        });
                        // OPCIONES AGENTE DE CAMBIOS
                        var optAgenCambSplit = infointeres.actividadesagentecambio.split(",");
                        var opcionesAgenteCambios = Array();
                        optAgenCambSplit.map(function (opc) {
                            var optionAgente = OpcionesList.ActividadesAgenteCambio.find(function (obj) { return obj.value === opc; });
                            opcionesAgenteCambios.push(optionAgente);
                        });
                        // TELEFONOS
                        var casaalumni = _this.state.telecasa;
                        var celularalumni = _this.state.telecel;
                        var celuExists = false;
                        var casaExists = false;
                        responseJsonInt.data.ttelefonos.map(function (ta) {
                            if (ta.tipotelefono === "C") {
                                celuExists = true;
                                celularalumni = ta;
                                if (ta.codigopais === "593") {
                                    celularalumni.codigoarea = "09";
                                }
                            }
                            else if (ta.tipotelefono === "D") {
                                casaExists = true;
                                casaalumni = ta;
                                if (ta.codigopais === "593" && ta.codigoarea.length < 2) {
                                    casaalumni.codigoarea = "0" + ta.codigoarea;
                                }
                            }
                        });
                        if (!celuExists) {
                            celularalumni.idpersona = idpersonaRJ;
                        }
                        if (!casaExists) {
                            casaalumni.idpersona = idpersonaRJ;
                        }
                        _this.setState({
                            infointeres: infointeres,
                            telecasa: casaalumni, telecel: celularalumni,
                            tipoFonoSelect: "C", cedulaModal: false, cedulaAlert: false,
                            cargandoValidAlert: false,
                            datosalumni: datosalumni1, idpersona: idpersonaRJ,
                            opcionesInteres: opcionesIntereses,
                            opcionesRedes: opcionesRedes,
                            opcionesAgenteCambio: opcionesAgenteCambios,
                            graduadode: carrerasgraduado,
                            loginModal: true
                        }, function () {
                            sweetalert2_1.default.close();
                            //console.log("telecasa: ", this.state.telecasa);
                            //console.log("telecel: ", this.state.telecel);
                            _this.cargarNacionalidad();
                            _this.showNewQuestions("tipoTelefonoAlumni", "C");
                        });
                    }
                    else {
                        var mensaje = "Ocurrió un error al obtener la información.";
                        //this.setState({ cedulaModal: true, cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });
                        console.log("Ocurrió un error en GetInformacionInteres.");
                        sweetalert2_1.default.fire({
                            title: '¡Oh no!',
                            text: 'Se ha producido un error al momento de obtener su información',
                            icon: 'error',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then(function (result) {
                            if (result.isConfirmed) {
                                sweetalert2_1.default.close();
                            }
                        });
                    }
                }, function (error) {
                    if (error.name === "AbortError") {
                        console.log("AbortError controlado");
                    }
                    else {
                        // INSTALAR SWEET ALERT PARA LOS MENSAJES DE ERROR
                        var mensaje = "Ocurrió un error al obtener la información.";
                        _this.setState({ cedulaModal: true, cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });
                        console.log("Ocurrió un error en GetInformacionInteres: " + error);
                        sweetalert2_1.default.fire({
                            title: '¡Oh no!',
                            text: 'Se ha producido un error al momento de obtener su información',
                            icon: 'error',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then(function (result) {
                            if (result.isConfirmed) {
                                sweetalert2_1.default.close();
                            }
                        });
                    }
                });
            }
            else {
                var mensaje = "Ocurrió un error al guardar la información de inicio de sesión.";
                //this.setState({ cedulaModal: true, cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });
                console.log("Ocurrió un error en PostDatosLogin: " + responsePost["strMensaje"]);
                sweetalert2_1.default.fire({
                    title: '¡Oh no!',
                    text: 'Se ha producido un error al momento de obtener su información',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then(function (result) {
                    if (result.isConfirmed) {
                        sweetalert2_1.default.close();
                    }
                });
            }
        }, function (error) {
            if (error.name === "AbortError") {
                console.log("AbortError controlado");
            }
            else {
                var mensaje = "Ocurrió un error al guardar la información de inicio de sesión.";
                //this.setState({ cedulaModal: true, cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });
                console.log("Ocurrió un error en PostDatosLogin: " + error);
                sweetalert2_1.default.fire({
                    title: '¡Oh no!',
                    text: 'Se ha producido un error al momento de guardar la información de inicio de sesión.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then(function (result) {
                    if (result.isConfirmed) {
                        sweetalert2_1.default.close();
                    }
                });
            }
        });
    };
    // FUNCION PARA INICIO DE SESION SIN LOGIN - SOLO CEDULA Y FECHA NACIMIENTO
    MiniFormulario.prototype.closeVerificacionCedulaMini = function (idpersonaRJ, datosalumni1, datospostgrados) {
        var _this = this;
        // OBTENIENDO INFORMACION DE INFO INTERES
        fetch(SERVER_URL + "Informacion/GetInformacionInteres/" + idpersonaRJ, { signal: this.abortController.signal })
            .then(function (response) { return response.json(); })
            .then(function (responseJsonInt) {
            if (responseJsonInt.status.isSuccessfully) {
                // INFORMACION PERSONAL
                var carrerasgraduado = Array();
                // agregando carrera de grado
                if (datosalumni1 !== null && datosalumni1.nombrecarrera !== null) {
                    carrerasgraduado.push(datosalumni1.nombrecarrera.toUpperCase());
                }
                // agregando carreras de postgrados
                if (datospostgrados !== null && datospostgrados.item !== null) {
                    if (datospostgrados.item.lPostgradosGraduados !== null && datospostgrados.item.lPostgradosGraduados.length > 0) {
                        var itemGradLength = datospostgrados.item.lPostgradosGraduados.length;
                        var lastthree = itemGradLength - 1;
                        while (lastthree >= 0 && carrerasgraduado.length <= 3) {
                            var carreraName = datospostgrados.item.lPostgradosGraduados[lastthree];
                            carrerasgraduado.push(carreraName.nombrePrograma.toUpperCase());
                            lastthree = lastthree - 1;
                        }
                    }
                }
                // INFORMACION INTERES
                var infointeres = responseJsonInt.data.tinteres;
                // OPCIONES INTERES
                var optIntSplit = infointeres.interes.split(",");
                var opcionesIntereses = Array();
                optIntSplit.map(function (opc) {
                    var optionInteres = OpcionesList.InteresList.find(function (obj) { return obj.value === opc; });
                    opcionesIntereses.push(optionInteres);
                });
                // OPCIONES REDES SOCIALES MAS USADAS
                var optRedSocialSplit = infointeres.redessociales.split(",");
                var opcionesRedes = Array();
                optRedSocialSplit.map(function (opc) {
                    var optionRedes = OpcionesList.RedesSocialesMasUsadas.find(function (obj) { return obj.value === opc; });
                    opcionesRedes.push(optionRedes);
                });
                // OPCIONES AGENTE DE CAMBIOS
                var optAgenCambSplit = infointeres.actividadesagentecambio.split(",");
                var opcionesAgenteCambios = Array();
                optAgenCambSplit.map(function (opc) {
                    var optionAgente = OpcionesList.ActividadesAgenteCambio.find(function (obj) { return obj.value === opc; });
                    opcionesAgenteCambios.push(optionAgente);
                });
                // TELEFONOS
                var casaalumni = _this.state.telecasa;
                var celularalumni = _this.state.telecel;
                var celuExists = false;
                var casaExists = false;
                responseJsonInt.data.ttelefonos.map(function (ta) {
                    if (ta.tipotelefono === "C") {
                        celuExists = true;
                        celularalumni = ta;
                        if (ta.codigopais === "593") {
                            celularalumni.codigoarea = "09";
                        }
                    }
                    else if (ta.tipotelefono === "D") {
                        casaExists = true;
                        casaalumni = ta;
                        if (ta.codigopais === "593" && ta.codigoarea.length < 2) {
                            casaalumni.codigoarea = "0" + ta.codigoarea;
                        }
                    }
                });
                if (!celuExists) {
                    celularalumni.idpersona = idpersonaRJ;
                }
                if (!casaExists) {
                    casaalumni.idpersona = idpersonaRJ;
                }
                _this.setState({
                    infointeres: infointeres,
                    telecasa: casaalumni, telecel: celularalumni,
                    tipoFonoSelect: "C", cedulaModal: false, cedulaAlert: false,
                    cargandoValidAlert: false,
                    datosalumni: datosalumni1, idpersona: idpersonaRJ,
                    opcionesInteres: opcionesIntereses,
                    opcionesRedes: opcionesRedes,
                    opcionesAgenteCambio: opcionesAgenteCambios,
                    graduadode: carrerasgraduado,
                    loginModal: true
                }, function () {
                    sweetalert2_1.default.close();
                    _this.cargarNacionalidad();
                    _this.showNewQuestions("tipoTelefonoAlumni", "C");
                });
            }
            else {
                var mensaje = "Ocurrió un error al obtener la información.";
                //this.setState({ cedulaModal: true, cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });
                console.log("Ocurrió un error en GetInformacionInteres.");
                sweetalert2_1.default.fire({
                    title: '¡Oh no!',
                    text: 'Se ha producido un error al momento de obtener su información',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then(function (result) {
                    if (result.isConfirmed) {
                        sweetalert2_1.default.close();
                    }
                });
            }
        }, function (error) {
            if (error.name === "AbortError") {
                console.log("AbortError controlado");
            }
            else {
                var mensaje = "Ocurrió un error al obtener la información.";
                _this.setState({ cedulaModal: true, cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });
                console.log("Ocurrió un error en GetInformacionInteres: " + error);
                sweetalert2_1.default.fire({
                    title: '¡Oh no!',
                    text: 'Se ha producido un error al momento de obtener su información',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then(function (result) {
                    if (result.isConfirmed) {
                        sweetalert2_1.default.close();
                    }
                });
            }
        });
    };
    MiniFormulario.prototype.showDatosInteres = function (idpersonaRJ, datosalumni1, datospostgrados, datosinteres, datostelefono) {
        var _this = this;
        // INFORMACION PERSONAL
        // ACTUALIZANDO EMAIL ALTERNO
        if (this.state.redSocial !== "" && this.state.redSocial !== "I") {
            datosinteres.emailalterno = this.state.emailRedsocial;
        }
        var carrerasgraduado = Array();
        // agregando carrera de grado
        if (datosalumni1 !== null && datosalumni1.nombrecarrera !== null) {
            carrerasgraduado.push(datosalumni1.nombrecarrera.toUpperCase());
        }
        // agregando carreras de postgrados
        if (datospostgrados !== null && datospostgrados.item !== null) {
            if (datospostgrados.item.lPostgradosGraduados !== null && datospostgrados.item.lPostgradosGraduados.length > 0) {
                var itemGradLength = datospostgrados.item.lPostgradosGraduados.length;
                var lastthree = itemGradLength - 1;
                while (lastthree >= 0 && carrerasgraduado.length <= 3) {
                    var carreraName = datospostgrados.item.lPostgradosGraduados[lastthree];
                    carrerasgraduado.push(carreraName.nombrePrograma.toUpperCase());
                    lastthree = lastthree - 1;
                }
            }
        }
        // INFORMACION INTERES
        var infointeres = datosinteres;
        // OPCIONES INTERES
        var optIntSplit = infointeres.interes.split(",");
        var opcionesIntereses = Array();
        optIntSplit.map(function (opc) {
            var optionInteres = OpcionesList.InteresList.find(function (obj) { return obj.value === opc; });
            opcionesIntereses.push(optionInteres);
        });
        // OPCIONES REDES SOCIALES MAS USADAS
        var optRedSocialSplit = infointeres.redessociales.split(",");
        var opcionesRedes = Array();
        optRedSocialSplit.map(function (opc) {
            var optionRedes = OpcionesList.RedesSocialesMasUsadas.find(function (obj) { return obj.value === opc; });
            opcionesRedes.push(optionRedes);
        });
        // OPCIONES AGENTE DE CAMBIOS
        var optAgenCambSplit = infointeres.actividadesagentecambio.split(",");
        var opcionesAgenteCambios = Array();
        optAgenCambSplit.map(function (opc) {
            var optionAgente = OpcionesList.ActividadesAgenteCambio.find(function (obj) { return obj.value === opc; });
            opcionesAgenteCambios.push(optionAgente);
        });
        // TELEFONOS
        var casaalumni = this.state.telecasa;
        var celularalumni = this.state.telecel;
        var celuExists = false;
        var casaExists = false;
        datostelefono.map(function (ta) {
            if (ta.tipotelefono === "C") {
                celuExists = true;
                celularalumni = ta;
                if (ta.codigopais === "593") {
                    celularalumni.codigoarea = "09";
                }
            }
            else if (ta.tipotelefono === "D") {
                casaExists = true;
                casaalumni = ta;
                if (ta.codigopais === "593" && ta.codigoarea.length < 2) {
                    casaalumni.codigoarea = "0" + ta.codigoarea;
                }
            }
        });
        if (!celuExists) {
            celularalumni.idpersona = idpersonaRJ;
        }
        if (!casaExists) {
            casaalumni.idpersona = idpersonaRJ;
        }
        this.setState({
            infointeres: infointeres,
            telecasa: casaalumni, telecel: celularalumni,
            tipoFonoSelect: "C", cedulaModal: false, cedulaAlert: false,
            cargandoValidAlert: false,
            datosalumni: datosalumni1, idpersona: idpersonaRJ,
            opcionesInteres: opcionesIntereses,
            opcionesRedes: opcionesRedes,
            opcionesAgenteCambio: opcionesAgenteCambios,
            graduadode: carrerasgraduado,
            loginModal: true
        }, function () {
            sweetalert2_1.default.close();
            _this.cargarNacionalidad();
            _this.showNewQuestions("tipoTelefonoAlumni", "C");
        });
    };
    MiniFormulario.prototype.getDatosInfoInteres = function (idpersonaRJ, datosalumni1, datospostgrados) {
        var _this = this;
        // OBTENIENDO INFORMACION DE INFO INTERES
        fetch(SERVER_URL + "Informacion/GetInformacionInteres/" + idpersonaRJ, { signal: this.abortController.signal })
            .then(function (response) { return response.json(); })
            .then(function (responseJsonInt) {
            if (responseJsonInt.status.isSuccessfully) {
                // INFORMACION PERSONAL
                // ACTUALIZANDO EMAIL ALTERNO
                if (_this.state.redSocial !== "" && _this.state.redSocial !== "I") {
                    responseJsonInt.data.tinteres.emailalterno = _this.state.emailRedsocial;
                }
                var carrerasgraduado = Array();
                // agregando carrera de grado
                if (datosalumni1 !== null && datosalumni1.nombrecarrera !== null) {
                    carrerasgraduado.push(datosalumni1.nombrecarrera.toUpperCase());
                }
                // agregando carreras de postgrados
                if (datospostgrados !== null && datospostgrados.item !== null) {
                    if (datospostgrados.item.lPostgradosGraduados !== null && datospostgrados.item.lPostgradosGraduados.length > 0) {
                        var itemGradLength = datospostgrados.item.lPostgradosGraduados.length;
                        var lastthree = itemGradLength - 1;
                        while (lastthree >= 0 && carrerasgraduado.length <= 3) {
                            var carreraName = datospostgrados.item.lPostgradosGraduados[lastthree];
                            carrerasgraduado.push(carreraName.nombrePrograma.toUpperCase());
                            lastthree = lastthree - 1;
                        }
                    }
                }
                // INFORMACION INTERES
                var infointeres = responseJsonInt.data.tinteres;
                // OPCIONES INTERES
                var optIntSplit = infointeres.interes.split(",");
                var opcionesIntereses = Array();
                optIntSplit.map(function (opc) {
                    var optionInteres = OpcionesList.InteresList.find(function (obj) { return obj.value === opc; });
                    opcionesIntereses.push(optionInteres);
                });
                // OPCIONES REDES SOCIALES MAS USADAS
                var optRedSocialSplit = infointeres.redessociales.split(",");
                var opcionesRedes = Array();
                optRedSocialSplit.map(function (opc) {
                    var optionRedes = OpcionesList.RedesSocialesMasUsadas.find(function (obj) { return obj.value === opc; });
                    opcionesRedes.push(optionRedes);
                });
                // OPCIONES AGENTE DE CAMBIOS
                var optAgenCambSplit = infointeres.actividadesagentecambio.split(",");
                var opcionesAgenteCambios = Array();
                optAgenCambSplit.map(function (opc) {
                    var optionAgente = OpcionesList.ActividadesAgenteCambio.find(function (obj) { return obj.value === opc; });
                    opcionesAgenteCambios.push(optionAgente);
                });
                // TELEFONOS
                var casaalumni = _this.state.telecasa;
                var celularalumni = _this.state.telecel;
                var celuExists = false;
                var casaExists = false;
                responseJsonInt.data.ttelefonos.map(function (ta) {
                    if (ta.tipotelefono === "C") {
                        celuExists = true;
                        celularalumni = ta;
                        if (ta.codigopais === "593") {
                            celularalumni.codigoarea = "09";
                        }
                    }
                    else if (ta.tipotelefono === "D") {
                        casaExists = true;
                        casaalumni = ta;
                        if (ta.codigopais === "593" && ta.codigoarea.length < 2) {
                            casaalumni.codigoarea = "0" + ta.codigoarea;
                        }
                    }
                });
                if (!celuExists) {
                    celularalumni.idpersona = idpersonaRJ;
                }
                if (!casaExists) {
                    casaalumni.idpersona = idpersonaRJ;
                }
                _this.setState({
                    infointeres: infointeres,
                    telecasa: casaalumni, telecel: celularalumni,
                    tipoFonoSelect: "C", cedulaModal: false, cedulaAlert: false,
                    cargandoValidAlert: false,
                    datosalumni: datosalumni1, idpersona: idpersonaRJ,
                    opcionesInteres: opcionesIntereses,
                    opcionesRedes: opcionesRedes,
                    opcionesAgenteCambio: opcionesAgenteCambios,
                    graduadode: carrerasgraduado,
                    loginModal: true
                }, function () {
                    sweetalert2_1.default.close();
                    _this.cargarNacionalidad();
                    _this.showNewQuestions("tipoTelefonoAlumni", "C");
                });
            }
            else {
                var mensaje = "Ocurrió un error al obtener la información.";
                //this.setState({ cedulaModal: true, cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });
                console.log("Ocurrió un error en GetInformacionInteres.");
                sweetalert2_1.default.fire({
                    title: 'Oh no!',
                    text: 'Se ha producido un error al momento de obtener su información',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then(function (result) {
                    if (result.isConfirmed) {
                        sweetalert2_1.default.close();
                    }
                });
            }
        }, function (error) {
            if (error.name === "AbortError") {
                console.log("AbortError controlado");
            }
            else {
                var mensaje = "Ocurrió un error al obtener la información.";
                //this.setState({ cedulaModal: true, cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });
                console.log("Ocurrió un error en GetInformacionInteres: " + error);
                sweetalert2_1.default.fire({
                    title: 'Oh no!',
                    text: 'Se ha producido un error al momento de obtener su información',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then(function (result) {
                    if (result.isConfirmed) {
                        sweetalert2_1.default.close();
                    }
                });
            }
        });
    };
    MiniFormulario.prototype.getDatosAlumni = function () {
        var _this = this;
        var diaNa = Number(this.state.dia);
        var mesNa = Number(this.state.mes);
        var anioNa = Number(this.state.anio);
        if (this.state.identificacion === "" || this.state.dia === "" || this.state.mes === "" || this.state.anio === "") {
            var mensaje = "Llene todos los campos.";
            this.setState({ cedulaAlert: true, mensajeAlerta: mensaje });
        }
        else if (diaNa < 1 || diaNa > 31 || mesNa < 1 || mesNa > 12) {
            var mensaje = "Fecha fuera de rango.";
            this.setState({ cedulaAlert: true, mensajeAlerta: mensaje });
        }
        else {
            this.setState({ cargandoValidAlert: true });
            fetch("api/InformacionPostgrado/GetIdPersona/" + this.state.identificacion, { signal: this.abortController.signal })
                .then(function (response) { return response.json(); })
                .then(function (responsejson) {
                if (responsejson["strEstado"] === "N") {
                    var mensaje = "No pertenece al grupo de alumni.";
                    _this.setState({ cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });
                }
                else if (diaNa !== Number(responsejson.tdatosalumni.diaCedulacion) || mesNa !== Number(responsejson.tdatosalumni.mesCedulacion) || anioNa !== Number(responsejson.tdatosalumni.anioCedulacion)) {
                    var mensaje = "Fecha de cedulación no coincide con los registros.";
                    _this.setState({ cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });
                }
                else {
                    document.getElementById("banner-banner").scrollIntoView({
                        behavior: "smooth", block: "start", inline: "center"
                    });
                    var idpersonaRJ = responsejson["tnumero"];
                    var datospostgrados = responsejson["tdatospostgrados"];
                    var datosalumni1 = responsejson["tdatosalumni"];
                    fetch(SERVER_URL + "Informacion/GetInformacionInteres/" + idpersonaRJ, { signal: _this.abortController.signal })
                        .then(function (response) { return response.json(); })
                        .then(function (responseJsonInt) {
                        if (responseJsonInt.status.isSuccessfully) {
                            var carrerasgraduado = Array();
                            // agregando carrera de grado
                            if (datosalumni1 !== null && datosalumni1.nombrecarrera !== null) {
                                carrerasgraduado.push(datosalumni1.nombrecarrera.toUpperCase());
                            }
                            // agregando carreras de postgrados
                            if (datospostgrados !== null && datospostgrados.item !== null) {
                                if (datospostgrados.item.lPostgradosGraduados !== null && datospostgrados.item.lPostgradosGraduados.length > 0) {
                                    var itemGradLength = datospostgrados.item.lPostgradosGraduados.length;
                                    var lastthree = itemGradLength - 1;
                                    while (lastthree >= 0 && carrerasgraduado.length <= 3) {
                                        var carreraName = datospostgrados.item.lPostgradosGraduados[lastthree];
                                        carrerasgraduado.push(carreraName.nombrePrograma.toUpperCase());
                                        lastthree = lastthree - 1;
                                    }
                                }
                            }
                            // INFORMACION INTERES
                            var infointeres = responseJsonInt.data.tinteres;
                            // OPCIONES INTERES
                            var optIntSplit = infointeres.interes.split(",");
                            var opcionesIntereses = Array();
                            optIntSplit.map(function (opc) {
                                var optionInteres = OpcionesList.InteresList.find(function (obj) { return obj.value === opc; });
                                opcionesIntereses.push(optionInteres);
                            });
                            // OPCIONES REDES SOCIALES MAS USADAS
                            var optRedSocialSplit = infointeres.redessociales.split(",");
                            var opcionesRedes = Array();
                            optRedSocialSplit.map(function (opc) {
                                var optionRedes = OpcionesList.RedesSocialesMasUsadas.find(function (obj) { return obj.value === opc; });
                                opcionesRedes.push(optionRedes);
                            });
                            // OPCIONES AGENTE DE CAMBIOS
                            var optAgenCambSplit = infointeres.actividadesagentecambio.split(",");
                            var opcionesAgenteCambios = Array();
                            optAgenCambSplit.map(function (opc) {
                                var optionAgente = OpcionesList.ActividadesAgenteCambio.find(function (obj) { return obj.value === opc; });
                                opcionesAgenteCambios.push(optionAgente);
                            });
                            // TELEFONOS
                            var casaalumni = _this.state.telecasa;
                            var celularalumni = _this.state.telecel;
                            var celuExists = false;
                            var casaExists = false;
                            responseJsonInt.data.ttelefonos.map(function (ta) {
                                if (ta.tipotelefono === "C") {
                                    celuExists = true;
                                    celularalumni = ta;
                                    if (ta.codigopais === "593") {
                                        celularalumni.codigoarea = "09";
                                    }
                                }
                                else if (ta.tipotelefono === "D") {
                                    casaExists = true;
                                    casaalumni = ta;
                                    if (ta.codigopais === "593" && ta.codigoarea.length < 2) {
                                        casaalumni.codigoarea = "0" + ta.codigoarea;
                                    }
                                }
                            });
                            if (!celuExists) {
                                celularalumni.idpersona = idpersonaRJ;
                            }
                            if (!casaExists) {
                                casaalumni.idpersona = idpersonaRJ;
                            }
                            _this.setState({
                                infointeres: infointeres,
                                telecasa: casaalumni, telecel: celularalumni,
                                tipoFonoSelect: "C", cedulaModal: false, cedulaAlert: false,
                                cargandoValidAlert: false,
                                datosalumni: datosalumni1, idpersona: idpersonaRJ,
                                opcionesInteres: opcionesIntereses,
                                opcionesRedes: opcionesRedes,
                                opcionesAgenteCambio: opcionesAgenteCambios,
                                graduadode: carrerasgraduado,
                                loginModal: true
                            }, function () {
                                _this.cargarNacionalidad();
                                _this.showNewQuestions("tipoTelefonoAlumni", "C");
                            });
                        }
                        else {
                            var mensaje = "Ocurrió un error al obtener la información.";
                            _this.setState({ cedulaModal: true, cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });
                            console.log("Ocurrió un error en GetInformacionInteres.");
                        }
                    }, function (error) {
                        if (error.name === "AbortError") {
                            console.log("AbortError controlado");
                        }
                        else {
                            var mensaje = "Ocurrió un error al obtener la información.";
                            _this.setState({ cedulaModal: true, cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });
                            console.log("Ocurrió un error en GetInformacionInteres: " + error);
                        }
                    });
                }
            }, function (error) {
                if (error.name === "AbortError") {
                    console.log("AbortError controlado");
                }
                else {
                    var mensaje = "Ocurrió un error al obtener la información.";
                    _this.setState({ cedulaModal: true, cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });
                    console.log("Ocurrió un error en InformacionPostgrado: " + error);
                }
            });
        }
    };
    MiniFormulario.prototype.showNewQuestions = function (name, answer) {
        if (name.startsWith("infint")) {
            var tnamesq = name.split("-");
            var dtointeresshow = this.state.infointeres;
            if (tnamesq[1] === "cargoempresa") {
                if (answer !== "" && answer !== null && answer !== "DO") {
                    dtointeresshow["niveldocencia"] = "";
                }
            }
            else if (tnamesq[1] === "interes") {
                if (dtointeresshow.interes.indexOf("O") !== -1) {
                    document.getElementById("otrointeresdiv").style.removeProperty("display");
                }
                else if (dtointeresshow.interes !== "" && dtointeresshow.interes !== null && dtointeresshow.interes.indexOf("O") === -1) {
                    document.getElementById("otrointeresdiv").style.display = "none";
                    document.getElementById("otrointeres").value = "";
                    dtointeresshow["otrointeres"] = "";
                }
            }
            this.setState({ infointeres: dtointeresshow });
        }
        else if (name === "tipoTelefonoAlumni") {
            //(document.getElementById("divheaderfonos") as HTMLInputElement).style.removeProperty("display");
            if (answer === "C") {
                var celular = this.state.telecel;
                // MOSTRAR CELULAR
                document.getElementById("divpaisfonocelu").style.removeProperty("display");
                document.getElementById("divareafonocelu").style.removeProperty("display");
                document.getElementById("divnumerofonocelu").style.removeProperty("display");
                // OCULTAR DOMICILIO
                document.getElementById("divpaisfonocasa").style.display = "none";
                document.getElementById("divareafonocasa").style.display = "none";
                document.getElementById("divnumerofonocasa").style.display = "none";
                if (celular.codigopais.trim() === "593") {
                    document.getElementById("areafonoincelalinp").disabled = true;
                }
                else {
                    document.getElementById("areafonoincelalinp").disabled = false;
                }
            }
            else if (answer === "D") {
                var domicilio = this.state.telecasa;
                // MOSTRAR DOMICILIO
                document.getElementById("divpaisfonocasa").style.removeProperty("display");
                document.getElementById("divareafonocasa").style.removeProperty("display");
                document.getElementById("divnumerofonocasa").style.removeProperty("display");
                // OCULTAR CELULAR
                document.getElementById("divpaisfonocelu").style.display = "none";
                document.getElementById("divareafonocelu").style.display = "none";
                document.getElementById("divnumerofonocelu").style.display = "none";
                if (domicilio.codigopais.trim() === "593") {
                    document.getElementById("areafonoselcasal").style.removeProperty("display");
                    document.getElementById("areafonoincasal").style.display = "none";
                }
                else if (domicilio.codigopais.trim() !== "593") {
                    document.getElementById("areafonoincasal").style.removeProperty("display");
                    document.getElementById("areafonoselcasal").style.display = "none";
                }
            }
        }
        else if (name.startsWith("fonocel-alum")) { // fonocel-alum-codigopais
            var telefonocel = this.state.telecel;
            var tnamete = name.split("-");
            if (tnamete[2] === "codigopais") {
                if (answer.trim() === "593") {
                    //(document.getElementById("areafonoincelalinp") as HTMLInputElement).value = "09";
                    telefonocel.codigoarea = "09";
                    document.getElementById("areafonoincelalinp").disabled = true;
                }
                else {
                    document.getElementById("areafonoincelalinp").disabled = false;
                }
            }
            this.setState({ telecel: telefonocel });
        }
        else if (name.startsWith("fonocasa-alum")) { // fonocasa-alum-codigopais
            var fonoMoment = name.split("-");
            if (fonoMoment[2] === "codigopais") {
                if (answer.trim() === "593") {
                    document.getElementById("areafonoselcasal").style.removeProperty("display");
                    document.getElementById("areafonoincasal").style.display = "none";
                }
                else if (answer.trim() !== "593") {
                    document.getElementById("areafonoincasal").style.removeProperty("display");
                    document.getElementById("areafonoselcasal").style.display = "none";
                }
            }
        }
    };
    MiniFormulario.prototype.exceptionsInput = function (event) {
        var validNum;
        if (event.key !== undefined) {
            validNum = event.key === "e" || event.key === "E" || event.key === "." || event.key === "+" || event.key === "-" || event.key === ",";
        }
        else if (event.keyCode !== undefined) {
            validNum = event.keyCode === 69 || event.keyCode === 190 || event.keyCode === 187 || event.keyCode === 189 || event.keyCode === 188;
        }
        return validNum && event.preventDefault();
    };
    MiniFormulario.prototype.handleChange = function (event) {
        if (event.target.name === "identificacion") {
            this.setState({ identificacion: event.target.value });
        }
        else if (event.target.name === "anioIden") {
            var valorA = event.target.value;
            if (event.target.value.length > 4) {
                valorA = event.target.value.slice(0, 4);
            }
            this.setState({ anio: valorA });
        }
        else if (event.target.name.startsWith("infint")) {
            var tnamei = event.target.name.split("-");
            var dtointeresin = this.state.infointeres;
            dtointeresin[tnamei[1]] = event.target.value;
            this.setState({ infointeres: dtointeresin });
        }
        else if (event.target.name.startsWith("fono")) {
            var tnamefi = event.target.name.split("-");
            if (tnamefi[0] === "fonocel") {
                var celalumni = this.state.telecel;
                celalumni[tnamefi[2]] = event.target.value;
                this.setState({ telecel: celalumni });
            }
            else if (tnamefi[0] === "fonocasa") {
                var domalumni = this.state.telecasa;
                domalumni[tnamefi[2]] = event.target.value;
                this.setState({ telecasa: domalumni });
            }
        }
        else if (event.target.name === "checkConsentimiento") {
            this.setState({ consentimiento: !this.state.consentimiento });
        }
    };
    MiniFormulario.prototype.handleSelectChange = function (selectedOption, selName) {
        var _this = this;
        if (selectedOption !== null) {
            if (selName.name === "diaIden") {
                this.setState({ dia: selectedOption.value });
            }
            else if (selName.name === "mesIden") {
                this.setState({ mes: selectedOption.value });
            }
            else if (selName.name === "tipoTelefonoAlumni") {
                this.setState({ tipoFonoSelect: selectedOption.value }, function () {
                    _this.showNewQuestions(selName.name, selectedOption.value);
                });
            }
            else if (selName.name.startsWith("infint")) {
                var tname = selName.name.split("-");
                var dtointeres = this.state.infointeres;
                var opcRedes = "";
                var ningunaRedes = false;
                var opcionesRedesEscape;
                var opcInteres = "";
                var opcionesIntEscape;
                var opcAgente = "";
                var ningunaAgente = false;
                var opcionesAgenteEscape;
                if (tname[1] === "redessociales") {
                    if (selectedOption.length <= 3) {
                        opcionesRedesEscape = selectedOption;
                        selectedOption.map(function (option) {
                            if (option.value === "N") {
                                ningunaRedes = true;
                            }
                            opcRedes = opcRedes + option.value + ",";
                        });
                        if (ningunaRedes) {
                            dtointeres["redessociales"] = "N,";
                            opcionesRedesEscape = OpcionesList.RedesSocialesMasUsadas.find(function (obj) { return obj.value === "N"; });
                        }
                        else {
                            dtointeres["redessociales"] = opcRedes;
                        }
                    }
                    else {
                        opcionesRedesEscape = this.state.opcionesRedes;
                    }
                    opcionesIntEscape = this.state.opcionesInteres;
                    opcionesAgenteEscape = this.state.opcionesAgenteCambio;
                }
                else if (tname[1] === "interes") {
                    if (selectedOption.length <= 3) {
                        opcionesIntEscape = selectedOption;
                        selectedOption.map(function (option) {
                            opcInteres = opcInteres + option.value + ",";
                        });
                        dtointeres["interes"] = opcInteres;
                    }
                    else {
                        opcionesIntEscape = this.state.opcionesInteres;
                    }
                    opcionesRedesEscape = this.state.opcionesRedes;
                    opcionesAgenteEscape = this.state.opcionesAgenteCambio;
                }
                else if (tname[1] === "actividadesagentecambio") {
                    if (selectedOption.length <= 3) {
                        opcionesAgenteEscape = selectedOption;
                        selectedOption.map(function (option) {
                            if (option.value === "N") {
                                ningunaAgente = true;
                            }
                            opcAgente = opcAgente + option.value + ",";
                        });
                        if (ningunaAgente) {
                            dtointeres["actividadesagentecambio"] = "N,";
                            opcionesAgenteEscape = OpcionesList.ActividadesAgenteCambio.find(function (obj) { return obj.value === "N"; });
                        }
                        else {
                            dtointeres["actividadesagentecambio"] = opcAgente;
                        }
                    }
                    else {
                        opcionesAgenteEscape = this.state.opcionesAgenteCambio;
                    }
                    opcionesRedesEscape = this.state.opcionesRedes;
                    opcionesIntEscape = this.state.opcionesInteres;
                }
                else {
                    dtointeres[tname[1]] = selectedOption.value;
                    opcionesRedesEscape = this.state.opcionesRedes;
                    opcionesIntEscape = this.state.opcionesInteres;
                    opcionesAgenteEscape = this.state.opcionesAgenteCambio;
                }
                this.setState({ infointeres: dtointeres, opcionesRedes: opcionesRedesEscape, opcionesInteres: opcionesIntEscape, opcionesAgenteCambio: opcionesAgenteEscape }, function () {
                    _this.showNewQuestions(selName.name, selectedOption.value);
                });
            }
            else if (selName.name.startsWith("fono")) {
                var tnamef = selName.name.split("-");
                if (tnamef[0] === "fonocel") {
                    var celalumni = this.state.telecel;
                    celalumni[tnamef[2]] = selectedOption.value;
                    this.setState({ telecel: celalumni }, function () {
                        _this.showNewQuestions(selName.name, selectedOption.value);
                    });
                }
                else if (tnamef[0] === "fonocasa") {
                    var domalumni = this.state.telecasa;
                    domalumni[tnamef[2]] = selectedOption.value;
                    this.setState({ telecasa: domalumni }, function () {
                        _this.showNewQuestions(selName.name, selectedOption.value);
                    });
                }
            }
        }
    };
    MiniFormulario.prototype.closeAlert = function (name) {
        if (name === "cedula") {
            this.setState({ cedulaAlert: false });
        }
        else if (name === "telefonos") {
            this.setState({ alertaTelefono: false, mensajeTelefono: [] });
        }
        else if (name === "paisresidencia") {
            this.setState({ alertPaisResidencia: false });
        }
    };
    MiniFormulario.prototype.validarTelefonos = function (fonocasa, fonocel) {
        var mensajes = Array();
        var tipoTeleActual = this.state.tipoFonoSelect;
        if (tipoTeleActual === "C") { // CELULAR
            if (fonocel["codigopais"].trim().length === 0) {
                mensajes.push("Ocurrió un error: Falta seleccionar país en información de teléfono");
            }
            if (fonocel["codigoarea"].trim().length === 0) {
                mensajes.push("Ocurrió un error: El código área debe contener mínimo 1 dígito.");
            }
            if (fonocel["codigoarea"].trim().length > 2) {
                mensajes.push("Ocurrió un error: El código área debe contener máximo 2 dígitos.");
            }
            if (fonocel["numerotelefono"].trim().length === 0) {
                mensajes.push("Ocurrió un error: El número de celular no puede quedar vacío");
            }
            if (fonocel["numerotelefono"].trim().length > 11) {
                mensajes.push("Ocurrió un error: El número de celular debe contener máximo 11 dígitos.");
            }
            if (fonocel["codigopais"] === "593" && fonocel["numerotelefono"].trim().length !== 8) {
                mensajes.push("Ocurrió un error: El número de celular debe contener 8 dígitos.");
            }
        }
        else if (tipoTeleActual === "D") { // DOMICILIO
            if (fonocasa["codigopais"].trim().length === 0) {
                mensajes.push("Ocurrió un error: Falta seleccionar país enb información de teléfono");
            }
            if (fonocasa["codigoarea"].trim().length === 0) {
                mensajes.push("Ocurrió un error: El código área debe contener mínimo 1 dígito.");
            }
            if (fonocasa["codigoarea"].trim().length > 2) {
                mensajes.push("Ocurrió un error: El código área debe contener máximo 2 dígitos.");
            }
            if (fonocasa["numerotelefono"].trim().length === 0) {
                mensajes.push("Ocurrió un error: El número de celular no puede quedar vacío");
            }
            if (fonocasa["numerotelefono"].trim().length > 11) {
                mensajes.push("Ocurrió un error: El número de domicilio debe contener máximo 11 dígitos.");
            }
            if (fonocasa["codigopais"] === "593" && fonocasa["numerotelefono"].trim().length !== 7) {
                mensajes.push("Ocurrió un error: El número de domicilio debe contener 8 dígitos.");
            }
        }
        if (mensajes.length > 0) {
            this.setState({ mensajeTelefono: mensajes });
            return 1;
        }
        else {
            return 0;
        }
    };
    MiniFormulario.prototype.handleSubmit = function (event) {
        var _this = this;
        event.preventDefault();
        var idpersona = this.state.idpersona;
        var dtoInteres = this.state.infointeres;
        var telefonoPost;
        var formValid = true;
        var resultTelef = this.validarTelefonos(this.state.telecasa, this.state.telecel);
        var paisDomicilio = this.state.infointeres.idpaisresidencia;
        if (resultTelef === 1) {
            formValid = false;
            this.setState({ alertaTelefono: true });
            document.getElementById("alertaTelefonos").scrollIntoView({
                behavior: "smooth", block: "center", inline: "center"
            });
        }
        if (paisDomicilio === 0) {
            formValid = false;
            this.setState({ alertPaisResidencia: true });
            document.getElementById("alertaPaisResidencia").scrollIntoView({
                behavior: "smooth", block: "center", inline: "center"
            });
        }
        if (formValid) {
            //this.setState({ modalEnd: true, alertCargando: true, alertError: false }, () => {
            //    (document.getElementById("informacion-personal") as HTMLInputElement).scrollIntoView({
            //        behavior: "smooth", block: "start", inline: "center"
            //    });
            //});
            document.getElementById("informacion-personal").scrollIntoView({
                behavior: "smooth", block: "start", inline: "center"
            });
            sweetalert2_1.default.fire({
                title: 'Cargando...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: function () {
                    sweetalert2_1.default.showLoading();
                }
            });
            if (this.state.tipoFonoSelect === "C") {
                telefonoPost = this.state.telecel;
            }
            else {
                telefonoPost = this.state.telecasa;
            }
            dtoInteres.tipotelefono = telefonoPost.tipotelefono;
            dtoInteres.codigopais = telefonoPost.codigopais;
            dtoInteres.codigoarea = telefonoPost.codigoarea;
            dtoInteres.numerotelefono = telefonoPost.numerotelefono;
            var datosFormulario = JSON.stringify({ "tidpersona": idpersona, "tinteres": dtoInteres, "ttelefono": telefonoPost });
            //console.log("datosFormulario: ", datosFormulario);
            fetch(SERVER_URL + "Formulario/PostDatosFormularioInteres", {
                method: 'POST', headers: { 'Content-Type': 'application/json' }, body: datosFormulario
            }).then(function (response) { return response.json(); })
                .then(function (responseJson) {
                if (responseJson.status.isSuccessfully) {
                    //this.setState({ alertExito: true, alertCargando: false });
                    sweetalert2_1.default.fire({
                        title: 'Registro exitoso',
                        text: 'Su información se ha registrado con éxito.',
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then(function (result) {
                        if (result.isConfirmed) {
                            _this.resetFormulario();
                        }
                    });
                }
                else {
                    console.log("Ocurrió un error al registrar: " + responseJson["strMensaje"]);
                    //this.setState({ alertError: true, alertCargando: false });
                    sweetalert2_1.default.fire({
                        title: 'Oh no!',
                        text: 'Se ha producido un error al momento de guardar la información.',
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then(function (result) {
                        if (result.isConfirmed) {
                            sweetalert2_1.default.close();
                        }
                    });
                }
            }).catch(function (error) {
                //this.setState({ alertError: true, alertCargando: false });
                console.log("Ocurrió un error al registrar: " + error);
                sweetalert2_1.default.fire({
                    title: 'Oh no!',
                    text: 'Se ha producido un error al momento de guardar la información.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then(function (result) {
                    if (result.isConfirmed) {
                        sweetalert2_1.default.close();
                    }
                });
            });
        }
    };
    MiniFormulario.prototype.resetFormulario = function () {
        this.setState({
            loading: true, error: null,
            identificacion: "", dia: "", mes: "", anio: "", idpersona: 0,
            loginUP: true, valDataUp: true,
            cedulaModal: true, cargandoValidAlert: false, cedulaAlert: false, mensajeAlerta: "",
            modalEnd: false, alertCargando: false, alertExito: false, alertError: false,
            loginModal: false,
            tieneDatosPostgrados: false, datosalumni: new DatosAlumni(), infointeres: new InfoInteres(),
            telecasa: new TblTelefonoInfo(), telecel: new TblTelefonoInfo(), tipoFonoSelect: "", alertaTelefono: false, mensajeTelefono: [],
            alertPaisResidencia: false,
            graduadode: [], opcionesInteres: [], opcionesRedes: [], opcionesAgenteCambio: [],
            loginOpen: true, redSocial: "", emailRedsocial: "", consentimiento: false
        });
    };
    MiniFormulario.prototype.showAvisoPrivacidad = function (event) {
        event.preventDefault();
        this.setState({ modalAviso: true });
    };
    MiniFormulario.prototype.closeAvisoPrivacidad = function () {
        this.setState({ modalAviso: false });
    };
    MiniFormulario.prototype.render = function () {
        var content = this.state.paisesSelectList.length > 0 && this.state.paisFonoSelectList.length > 0
            ?
                this.renderForm(this.state.paisesSelectList, this.state.paisFonoSelectList)
            :
                React.createElement("div", { className: "loading" },
                    React.createElement("div", { className: "spinner-border text-secondary", role: "status" },
                        React.createElement("span", { className: "visually-hidden" })),
                    React.createElement("span", null, "\u00A0Cargando"));
        return (React.createElement("div", null, content));
    };
    MiniFormulario.prototype.renderForm = function (paisesList, paisesFonoList) {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement("img", { id: "banner-banner", src: Banner, alt: "", style: { width: "100%" } }),
            React.createElement("div", { className: "col-sm-1" }),
            React.createElement("div", { className: "container-fluid col-sm-10" },
                React.createElement(reactstrap_1.Modal, { isOpen: this.state.cedulaModal, centered: true, size: "lg" },
                    React.createElement(reactstrap_1.ModalHeader, { className: "modal-header-style" }, "Validaci\u00F3n de datos"),
                    React.createElement(reactstrap_1.ModalBody, null,
                        React.createElement(verificacion_cedula_mini_js_1.default, { closeVerificacionCedulaMini: this.closeVerificacionCedulaMini }))),
                React.createElement(reactstrap_1.Modal, { id: "avisoModalContent", isOpen: this.state.modalAviso, toggle: this.closeAvisoPrivacidad, size: "xl", centered: true },
                    React.createElement(reactstrap_1.ModalHeader, { className: "modal-header-style" }, "Aviso de privacidad de datos personales de alumni"),
                    React.createElement(reactstrap_1.ModalBody, null,
                        React.createElement(aviso_privacidad_js_1.default, null)),
                    React.createElement(reactstrap_1.ModalFooter, null,
                        React.createElement("button", { type: "button", className: "btn btn-light close-button", onClick: this.closeAvisoPrivacidad }, "Cerrar"))),
                React.createElement(reactstrap_1.Modal, { isOpen: this.state.modalEnd, centered: true },
                    React.createElement(reactstrap_1.ModalBody, null,
                        React.createElement(reactstrap_1.Alert, { isOpen: this.state.alertCargando, color: "light" },
                            React.createElement("div", { className: "spinner-border text-secondary", role: "status" },
                                React.createElement("span", { className: "visually-hidden" })),
                            "\u00A0Cargando"),
                        React.createElement(reactstrap_1.Alert, { isOpen: this.state.alertExito }, "Su formulario se ha registrado con \u00E9xito."),
                        React.createElement(reactstrap_1.Alert, { isOpen: this.state.alertError, color: "danger" }, "Se ha producido un error al momento de guardar la informaci\u00F3n."),
                        React.createElement("div", { className: "form-group row", id: "cerrarForm", style: { float: "right" } },
                            React.createElement("button", { type: "button", className: "btn btn-info buttonSpace", disabled: this.state.alertCargando, onClick: this.resetFormulario }, "Cerrar")))),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("form", { id: "alumniform-interes", name: "alumniform-interes", onSubmit: this.handleSubmit },
                    React.createElement("div", { id: "personal-section" },
                        React.createElement("div", { className: "blue-border", style: { paddingLeft: "20px", paddingRight: "20px" } },
                            React.createElement("div", { id: "informacion-personal" },
                                React.createElement("div", { className: "form-group row section-title" },
                                    React.createElement("div", { style: { backgroundColor: "white" } },
                                        React.createElement("img", { src: TriagunloAzul, alt: "", className: "small-icon", style: { width: "50px", height: "50px" } }),
                                        React.createElement("h5", { className: "down blue-text small-h5title" }, "INFORMACI\u00D3N PERSONAL"))),
                                React.createElement("br", null),
                                React.createElement("div", { className: "form-group row" },
                                    React.createElement("h5", { className: "col-sm-12 blue-text" }, "Datos Personales")),
                                React.createElement("div", { className: "form-group row no-margin-bottom" },
                                    React.createElement("div", { className: "col-lg-4 col-sm-8 label-space" },
                                        React.createElement("label", { className: "control-label", htmlFor: "nombrealumni" }, "Nombres y Apellidos"),
                                        React.createElement("input", { className: "form-control form-control-sm", type: "text", value: this.state.datosalumni.nombrecompleto, name: "nombrealumni", id: "nombrealumni", disabled: true })),
                                    React.createElement("div", { className: "col-lg-2 col-sm-4 label-space" },
                                        React.createElement("label", { className: "control-label", htmlFor: "identalumni" }, "Identificaci\u00F3n"),
                                        React.createElement("input", { className: "form-control form-control-sm", type: "text", value: this.state.datosalumni.numeroidentificacion, name: "identalumni", id: "identalumni", disabled: true })),
                                    React.createElement("div", { className: "col-lg-2 col-sm-4 label-space" },
                                        React.createElement("label", { className: "control-label", htmlFor: "nacionalidad" }, "Nacionalidad"),
                                        React.createElement("input", { className: "form-control form-control-sm", type: "text", name: "nacionalidad", id: "nacionalidad", disabled: true })),
                                    React.createElement("div", { className: "col-lg-2 col-sm-4 label-space" },
                                        React.createElement("label", { className: "control-label", htmlFor: "fechanacim" }, "Fecha de nacimiento"),
                                        React.createElement("div", { className: "input-group input-group-sm mb-3" },
                                            React.createElement("input", { className: "form-control form-control-sm", type: "text", name: "fechanacim", id: "fechanacim", disabled: true, value: this.state.datosalumni.fechanacimiento !== "" ? new Date(this.state.datosalumni.fechanacimiento).toLocaleDateString() : "" }),
                                            React.createElement("span", { className: "input-group-text", id: "fechanacicon" },
                                                React.createElement(FaIcons.FaCalendarAlt, null)))),
                                    React.createElement("div", { className: "col-lg-2 col-sm-4 label-space" },
                                        React.createElement("label", { className: "control-label", htmlFor: "estcivil" }, "Estado Civil"),
                                        React.createElement(select_modif_js_1.default, { options: OpcionesList.EstadoCivil, value: this.state.datosalumni.estadocivil, name: "estcivil", id: "estcivil", tipoicono: "estadocivil", disabled: true }))),
                                React.createElement("div", { className: "form-group row" },
                                    React.createElement("div", { className: "col-lg-4 col-sm-12 label-space" },
                                        React.createElement("label", { className: "control-label", htmlFor: "carrera" }, "Graduado de:"),
                                        this.state.graduadode.map(function (carrera, index) {
                                            return (React.createElement("input", { className: "form-control form-control-sm", type: "text", value: carrera, key: index, style: { marginBottom: "10px" }, disabled: true }));
                                        })),
                                    React.createElement("div", { className: "col-lg-8 col-sm-12" },
                                        React.createElement("div", { className: "form-group row" },
                                            React.createElement("div", { className: "col-lg-3 col-sm-4 label-space" },
                                                React.createElement("label", { className: "control-label", htmlFor: "emailalumni" }, "E-mail ESPOL"),
                                                React.createElement("input", { className: "form-control form-control-sm", type: "text", value: this.state.datosalumni.email, name: "emailalumni", id: "emailalumni", disabled: true }))))),
                                React.createElement("br", null),
                                React.createElement("div", { id: "alertaPaisResidencia" },
                                    React.createElement(reactstrap_1.Alert, { isOpen: this.state.alertPaisResidencia, color: "danger", toggle: function () { return _this.closeAlert("paisresidencia"); } }, "Pa\u00EDs de residencia no puede quedar sin responder.")),
                                React.createElement("div", { className: "form-group row" },
                                    React.createElement("h5", { className: "col-sm-12 blue-text" }, "Contacto")),
                                React.createElement("div", { className: "form-group row" },
                                    React.createElement("div", { className: "col-lg-6 col-sm-12 label-space" },
                                        React.createElement("label", { className: "control-label", htmlFor: "paisalumni" },
                                            "Pa\u00EDs Residencia",
                                            React.createElement("span", { className: "required-field" }, "*")),
                                        React.createElement(select_modif_js_1.default, { options: paisesList, value: this.state.infointeres.idpaisresidencia, name: "infint-idpaisresidencia", id: "paisalumni", placeholder: "Elija...", onChange: this.handleSelectChange, tipoicono: "pais" })),
                                    React.createElement("div", { className: "col-lg-6 col-sm-12 label-space" },
                                        React.createElement("label", { className: "control-label", htmlFor: "emailalterno" },
                                            "E-mail Personal ",
                                            React.createElement("span", { className: "required-field" }, "*")),
                                        React.createElement("div", { className: "input-group input-group-sm mb-3" },
                                            React.createElement("input", { className: "form-control form-control-sm", type: "email", value: this.state.infointeres.emailalterno, name: "infint-emailalterno", id: "emailalterno", maxLength: 99, onChange: this.handleChange, required: true }),
                                            React.createElement("span", { className: "input-group-text span-background", id: "mailalumnis" },
                                                React.createElement(AiIcons.AiOutlineMail, { style: { color: "white" } }))))),
                                React.createElement("div", { id: "alertaTelefonos" },
                                    React.createElement(reactstrap_1.Alert, { isOpen: this.state.alertaTelefono, color: "danger", toggle: function () { return _this.closeAlert("telefonos"); } }, this.state.mensajeTelefono)),
                                React.createElement("div", { className: "form-group row", id: "divheaderfonos", style: { marginBottom: "0px" } },
                                    React.createElement("div", { className: "col-lg-3 col-sm-3" }),
                                    React.createElement("div", { className: "col-lg-6 col-sm-9", style: { paddingLeft: "5px" } },
                                        React.createElement("h6", { className: "blue-text" },
                                            "Tel\u00E9fono - ",
                                            this.state.tipoFonoSelect === "C" ? "Celular" : "Domicilio"))),
                                React.createElement("div", { className: "form-group row no-margin-bottom" },
                                    React.createElement("div", { className: "col-lg-3 col-sm-3 label-space" },
                                        React.createElement("label", { className: "control-label" }, "Tipo Tel\u00E9fono"),
                                        React.createElement(select_modif_js_1.default, { options: OpcionesList.TipoTelefonoList, value: this.state.tipoFonoSelect, name: "tipoTelefonoAlumni", id: "tipofonoalum", placeholder: "Elija...", onChange: this.handleSelectChange, tipoicono: "telefono" })),
                                    React.createElement("div", { className: "col-lg-3 col-sm-3 label-space", id: "divpaisfonocelu", style: { display: "none" } },
                                        React.createElement("label", { className: "control-label" }, "C\u00F3digo Pa\u00EDs\u00A0"),
                                        React.createElement(select_modif_js_1.default, { options: paisesFonoList, value: this.state.telecel.codigopais, name: "fonocel-alum-codigopais", id: "paisfonocelal", placeholder: "Elija...", onChange: this.handleSelectChange, tipoicono: "pais" })),
                                    React.createElement("div", { className: "col-lg-3 col-sm-3 label-space", id: "divareafonocelu", style: { display: "none" } },
                                        React.createElement("label", { className: "control-label" }, "C\u00F3digo \u00E1rea/estado\u00A0"),
                                        React.createElement("div", { className: "input-group input-group-sm mb-3", id: "areafonoincelal" },
                                            React.createElement("input", { className: "form-control form-control-sm", id: "areafonoincelalinp", name: "fonocel-alum-codigoarea", value: this.state.telecel.codigoarea, type: "number", onChange: this.handleChange, onKeyDown: this.exceptionsInput }),
                                            React.createElement("span", { className: "input-group-text span-background", id: "codare2aicon" },
                                                React.createElement(AiIcons.AiOutlineAim, { style: { color: "white" } })))),
                                    React.createElement("div", { className: "col-lg-3 col-sm-3 label-space", id: "divnumerofonocelu", style: { display: "none" } },
                                        React.createElement("label", { className: "control-label", htmlFor: "fononumbercelal" }, "N\u00FAmero\u00A0"),
                                        React.createElement("div", { className: "input-group input-group-sm mb-3" },
                                            React.createElement("input", { className: "form-control form-control-sm", type: "number", value: this.state.telecel.numerotelefono, name: "fonocel-alum-numerotelefono", id: "fononumbercelal", onChange: this.handleChange, onKeyDown: this.exceptionsInput }),
                                            React.createElement("span", { className: "input-group-text span-background", id: "number2icon" },
                                                React.createElement(AiIcons.AiOutlineNumber, { style: { color: "white" } })))),
                                    React.createElement("div", { className: "col-lg-3 col-sm-3 label-space", id: "divpaisfonocasa", style: { display: "none" } },
                                        React.createElement("label", { className: "control-label" }, "C\u00F3digo Pa\u00EDs\u00A0"),
                                        React.createElement(select_modif_js_1.default, { options: paisesFonoList, value: this.state.telecasa.codigopais, name: "fonocasa-alum-codigopais", id: "paisfonocasal", placeholder: "Elija...", onChange: this.handleSelectChange, tipoicono: "pais" })),
                                    React.createElement("div", { className: "col-lg-3 col-sm-3 label-space", id: "divareafonocasa", style: { display: "none" } },
                                        React.createElement("label", { className: "control-label" }, "C\u00F3digo \u00E1rea/estado\u00A0"),
                                        React.createElement("div", { id: "areafonoselcasal", style: { display: "none" } },
                                            React.createElement(select_modif_js_1.default, { options: OpcionesList.AreaFonoList, value: this.state.telecasa.codigoarea, name: "fonocasa-alum-codigoarea", id: "areafonoselcasal1", placeholder: "Elija...", onChange: this.handleSelectChange, tipoicono: "codarea" })),
                                        React.createElement("div", { className: "input-group input-group-sm mb-3", id: "areafonoincasal" },
                                            React.createElement("input", { className: "form-control form-control-sm", name: "fonocasa-alum-codigoarea", type: "number", value: this.state.telecasa.codigoarea, onChange: this.handleChange, onKeyDown: this.exceptionsInput }),
                                            React.createElement("span", { className: "input-group-text span-background", id: "codare1aicon" },
                                                React.createElement(AiIcons.AiOutlineAim, { style: { color: "white" } })))),
                                    React.createElement("div", { className: "col-lg-3 col-sm-3 label-space", id: "divnumerofonocasa", style: { display: "none" } },
                                        React.createElement("label", { className: "control-label", htmlFor: "fononumbercasal" }, "N\u00FAmero\u00A0"),
                                        React.createElement("div", { className: "input-group input-group-sm mb-3" },
                                            React.createElement("input", { className: "form-control form-control-sm", type: "number", value: this.state.telecasa.numerotelefono, name: "fonocasa-alum-numerotelefono", id: "fononumbercasal", onChange: this.handleChange, onKeyDown: this.exceptionsInput }),
                                            React.createElement("span", { className: "input-group-text span-background", id: "number1icon" },
                                                React.createElement(AiIcons.AiOutlineNumber, { style: { color: "white" } }))))),
                                React.createElement("br", null),
                                React.createElement("div", { className: "form-group row" },
                                    React.createElement("div", { className: "col-sm-12 label-space" },
                                        React.createElement("label", { className: "control-label", htmlFor: "situacionlaboral" },
                                            "\u00BFCu\u00E1l es su situaci\u00F3n laboral actual? ",
                                            React.createElement("span", { className: "required-field" }, "*")),
                                        React.createElement(required_select_js_1.default, { options: OpcionesList.SitlaboralList, name: "infint-situacionlaboral", id: "situacionlaboral", placeholder: "Elija una opci\u00F3n...", onChange: this.handleSelectChange, value: this.state.infointeres.situacionlaboral ? this.state.infointeres.situacionlaboral : '', isDisabled: false, required: true, isMulti: false }))),
                                (this.state.infointeres.situacionlaboral !== "BPT" && this.state.infointeres.situacionlaboral !== "SE" && this.state.infointeres.situacionlaboral !== "ND" && this.state.infointeres.situacionlaboral !== "PN" && this.state.infointeres.situacionlaboral !== "") && (React.createElement("div", { className: "form-group row" },
                                    React.createElement("div", { className: "col-md-6 two-col-row label-space" },
                                        React.createElement("label", { className: "control-label", htmlFor: "nombreempresa", style: { marginTop: "18px" } },
                                            "\u00BFCu\u00E1l es el nombre de la empresa en que se encuentre laborando? ",
                                            React.createElement("span", { className: "required-field" }, "*")),
                                        React.createElement("input", { className: "form-control form-control-sm", type: "text", value: this.state.infointeres.nombreempresa, name: "infint-nombreempresa", id: "nombreempresa", onChange: this.handleChange, maxLength: 999, required: this.state.infointeres.situacionlaboral !== "BPT" && this.state.infointeres.situacionlaboral !== "SE" && this.state.infointeres.situacionlaboral !== "ND" && this.state.infointeres.situacionlaboral !== "PN" && this.state.infointeres.situacionlaboral !== "" })),
                                    React.createElement("div", { className: "col-md-6 two-col-row label-space" },
                                        React.createElement("label", { className: "control-label", htmlFor: "cargoemp", style: { marginTop: "18px" } },
                                            "Catalogue el cargo que desempe\u00F1a dentro de las siguientes opciones ",
                                            React.createElement("span", { className: "required-field" }, "*")),
                                        React.createElement(required_select_js_1.default, { options: OpcionesList.CargoList, name: "infint-cargoempresa", id: "cargoemp", placeholder: "Elija una opci\u00F3n...", onChange: this.handleSelectChange, value: this.state.infointeres.cargoempresa ? this.state.infointeres.cargoempresa : '', isDisabled: false, isMulti: false, required: this.state.infointeres.situacionlaboral !== "BPT" && this.state.infointeres.situacionlaboral !== "SE" && this.state.infointeres.situacionlaboral !== "ND" && this.state.infointeres.situacionlaboral !== "PN" && this.state.infointeres.situacionlaboral !== "" })))),
                                (this.state.infointeres.cargoempresa === "DO") && (React.createElement("div", { className: "form-group row", id: "docentepregunta" },
                                    React.createElement("div", { className: "col-md-6 two-col-row" }),
                                    React.createElement("div", { className: "col-md-6 two-col-row label-space" },
                                        React.createElement("label", { className: "control-label", htmlFor: "niveldocencia" },
                                            "Indique su nivel de docencia ",
                                            React.createElement("span", { className: "required-field" }, "*")),
                                        React.createElement(required_select_js_1.default, { options: OpcionesList.NiveldocenciaList, name: "infint-niveldocencia", id: "niveldocencia", placeholder: "Elija una opci\u00F3n...", onChange: this.handleSelectChange, value: this.state.infointeres.niveldocencia ? this.state.infointeres.niveldocencia : '', isDisabled: false, required: this.state.infointeres.cargoempresa === "DO", isMulti: false })))),
                                React.createElement("div", { className: "form-group row" },
                                    React.createElement("div", { className: "col-sm-12 label-space" },
                                        React.createElement("label", { className: "control-label", htmlFor: "redessociales" },
                                            "\u00BFCu\u00E1les son las 3 redes sociales que m\u00E1s frecuentas? ",
                                            React.createElement("span", { className: "required-field" }, "*")),
                                        React.createElement(required_select_js_1.default, { options: OpcionesList.RedesSocialesMasUsadas, name: "infint-redessociales", id: "redessociales", placeholder: "Elija hasta tres opciones...", onChange: this.handleSelectChange, value: this.state.opcionesRedes, isDisabled: false, required: true, isMulti: true }))),
                                React.createElement("br", null)))),
                    React.createElement("br", null),
                    React.createElement("br", null),
                    React.createElement("div", { id: "interes-section" },
                        React.createElement("div", { className: "green-border", style: { paddingLeft: "20px", paddingRight: "20px" } },
                            React.createElement("div", { id: "informacion-interes" },
                                React.createElement("div", { className: "form-group row section-title" },
                                    React.createElement("div", { style: { backgroundColor: "white" } },
                                        React.createElement("img", { src: TrianguloVerde, alt: "", className: "small-icon", style: { width: "50px", height: "50px" } }),
                                        React.createElement("h5", { className: "down green-text small-h5title" }, "INTERESES"))),
                                React.createElement("br", null),
                                React.createElement("div", { className: "form-group row" },
                                    React.createElement("div", { className: "col-sm-12 label-space" },
                                        React.createElement("label", { className: "control-label", htmlFor: "interesesalum" },
                                            "\u00BFQu\u00E9 actividad(es) le gustar\u00EDa tener y/o mantener como graduado / alumni ESPOL? ",
                                            React.createElement("span", { className: "required-field" }, "*")),
                                        React.createElement(required_select_js_1.default, { options: OpcionesList.InteresList, name: "infint-interes", id: "interesesalum", placeholder: "Elija hasta tres opciones...", onChange: this.handleSelectChange, value: this.state.opcionesInteres, isDisabled: false, required: true, isMulti: true }))),
                                React.createElement("div", { className: "form-group row", id: "otrointeresdiv", style: { display: "none" } },
                                    React.createElement("div", { className: "col-sm-12 label-space" },
                                        React.createElement("textarea", { className: "form-control form-control-sm", value: this.state.infointeres.otrointeres, name: "infint-otrointeres", id: "otrointeres", rows: 3, maxLength: 99, placeholder: "Escriba otros intereses...", onChange: this.handleChange, style: { fontSize: "small" } }))),
                                React.createElement("div", { className: "form-group row" },
                                    React.createElement("div", { className: "col-sm-12 label-space" },
                                        React.createElement("label", { className: "control-label", htmlFor: "agentecambio" },
                                            "Te invitamos a ser un agente de cambio para los futuros polit\u00E9cnicos. Selecciona las actividades de tu preferencia: ",
                                            React.createElement("span", { className: "required-field" }, "*")),
                                        React.createElement(required_select_js_1.default, { options: OpcionesList.ActividadesAgenteCambio, name: "infint-actividadesagentecambio", id: "agentecambio", placeholder: "Elija hasta tres opciones...", onChange: this.handleSelectChange, value: this.state.opcionesAgenteCambio, isDisabled: false, required: true, isMulti: true }))),
                                React.createElement("div", { className: "form-group row" },
                                    React.createElement("div", { className: "col-sm-12 label-space" },
                                        React.createElement("label", { className: "control-label", htmlFor: "mediocontacto" },
                                            "\u00BFCu\u00E1l es tu medio de contacto preferido para que te contactemos? ",
                                            React.createElement("span", { className: "required-field" }, "*")),
                                        React.createElement(required_select_js_1.default, { options: OpcionesList.MedioContacto, name: "infint-mediocontacto", id: "mediocontacto", placeholder: "Elija una opci\u00F3n...", onChange: this.handleSelectChange, value: this.state.infointeres.mediocontacto, isDisabled: false, required: true, isMulti: false }))),
                                React.createElement("br", null)))),
                    React.createElement("br", null),
                    React.createElement("div", { className: "col-12" },
                        React.createElement("div", { className: "col-12" },
                            React.createElement("p", { style: { fontWeight: "bold" } },
                                "AVISO DE PRIVACIDAD ",
                                React.createElement("span", { className: "required-field" }, "*"))),
                        React.createElement("div", { className: "form-group form-check" },
                            React.createElement("input", { type: "checkbox", className: "form-check-input", id: "checkConsentimiento", name: "checkConsentimiento", onChange: this.handleChange, checked: this.state.consentimiento, required: true }),
                            React.createElement("label", { className: "form-check-label", htmlFor: "checkConsentimiento", style: { textAlign: "justify", fontSize: "small", fontWeight: "unset" } },
                                "He le\u00EDdo y acepto la ",
                                React.createElement("a", { onClick: this.showAvisoPrivacidad, style: { textDecoration: "underline", color: "#223163", cursor: "pointer" } }, "pol\u00EDtica de privacidad"),
                                "."))),
                    React.createElement("br", null),
                    React.createElement("div", null,
                        React.createElement("label", { style: { fontSize: "large" } },
                            "(",
                            React.createElement("span", { className: "required-field" }, "*"),
                            ") Campos requeridos")),
                    React.createElement("br", null),
                    React.createElement("br", null),
                    React.createElement("div", { className: "form-group row", id: "siguiente-interes", style: { float: "right" } },
                        React.createElement("button", { type: "submit", className: "btn btn-success buttonSpace" }, "Guardar")))),
            React.createElement("div", { className: "col-sm-1" })));
    };
    return MiniFormulario;
}(React.Component));
exports.MiniFormulario = MiniFormulario;
exports.default = MiniFormulario;
//# sourceMappingURL=MiniFormulario.js.map